module.exports = '3.15.0';



// WEBPACK FOOTER //
// ./src/version.js